import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function SessionAlert({
  body,
  cta,
  title,
  type
}) {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "live-event-registration-alert",
    marginBlock: "800",
    titleText: title,
    type: type,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: isMobile ? 'stretch' : 'center',
      flexDirection: isMobile ? 'column' : 'row',
      flexGrow: 1,
      gap: "400",
      inlineSize: "100%",
      justifyContent: "space-between",
      children: [body, cta]
    })
  });
}
const LiveEventRegistrationAlert = ({
  hasLiveSession,
  hasRegisteredUpcoming,
  isLiveSessionRegistered,
  joinUrl,
  pastRecording,
  viewRegisteredEventsTo
}) => {
  if (hasLiveSession && isLiveSessionRegistered) {
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.liveRegisteredBody"
      }),
      cta: joinUrl ? /*#__PURE__*/_jsx(Button, {
        external: true,
        href: joinUrl,
        target: "_blank",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.joinSession"
        })
      }) : undefined,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.liveNowTitle"
      }),
      type: "success"
    });
  }
  if (hasLiveSession) {
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.liveUnregisteredBody"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.liveNowTitle"
      }),
      type: "success"
    });
  }
  if (hasRegisteredUpcoming) {
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.upcomingRegisteredBody"
      }),
      cta: /*#__PURE__*/_jsx(RouterButton, {
        to: viewRegisteredEventsTo,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.viewRegisteredEvents"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.registeredTitle"
      }),
      type: "info"
    });
  }
  if (pastRecording) {
    const body = pastRecording.attended ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.liveEventOverviewModal.alert.pastAttendedBody"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.liveEventOverviewModal.alert.pastRegisteredBody"
    });
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: body,
      cta: /*#__PURE__*/_jsx(Button, {
        external: true,
        href: pastRecording.recordingUrl,
        target: "_blank",
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.watchRecording"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.liveEventOverviewModal.alert.watchRecordingTitle"
      }),
      type: "tip"
    });
  }
  return null;
};
export { LiveEventRegistrationAlert };